export const waitUntil = (condition: () => boolean): Promise<void> => {
  return new Promise(resolve => {
    const checkCondition = (): void => {
      if (condition()) {
        resolve();
      } else {
        requestAnimationFrame(checkCondition);
      }
    };
    checkCondition();
  });
};

export const waitUntilWithInterval = (
  condition: () => boolean,
  checkInterval = 30,
): Promise<void> => {
  return new Promise(resolve => {
    const interval = setInterval(() => {
      if (!condition()) return;
      clearInterval(interval);
      resolve();
    }, checkInterval);
  });
};
